<template>
  <div class="details_content_repeat">
    <QS-h4-title title="车辆信息" />
    <QS-common-table
      :data="carInfo"
      :columns="carInfoHeader"
      :pagination="false"
    ></QS-common-table>

    <p class="txt-right">
      进行中车辆数：{{`${progressCarTotalNum}` || 0}} 台
    </p>
    <p class="txt-right">
      已关闭车辆数：{{`${closeCarTotalNum}` || 0}} 台
    </p>
  </div>
</template>

<script>

export default {
  name: 'CarInfo',
  props: {
    carInfo: {
      type: Array,
    },
  },
  computed: {
    // 进行中车辆数
    progressCarTotalNum() {
      let total = []
      total = this.calculatorSum(2)
      return total
    },
    // 已关闭车辆数
    closeCarTotalNum() {
      let total = []
      total = this.calculatorSum(4)
      return total
    },
  },

  data() {
    return {
      // 车辆信息表头
      carInfoHeader: [
        {
          name: 'index',
          columnProps: {
            label: '序号',
            prop: 'index',
          },
        },
        {
          name: 'brandName',
          columnProps: {
            prop: 'brandName',
            label: '品牌',
          },
        },
        {
          name: 'seriesName',
          columnProps: {
            prop: 'seriesName',
            label: '车系',
          },
        },
        {
          name: 'carModel',
          columnProps: {
            prop: 'carModel',
            label: '车型',
          },
        },
        {
          name: 'carId',
          columnProps: {
            prop: 'carId',
            label: '车辆ID',
          },
        },
        {
          name: 'plateNo',
          columnProps: {
            label: '车牌号',
            prop: 'plateNo',
            width: 100,
          },
        },
        {
          name: 'vin',
          columnProps: {
            prop: 'vin',
            label: 'VIN码',
          },
        },
        {
          name: 'deptName',
          columnProps: {
            prop: 'deptName',
            label: '所属部门',
          },
        },
        {
          name: 'rentAmount',
          columnProps: {
            prop: 'rentAmount',
            label: '每期金额',
          },
        },
        {
          name: 'state',
          columnProps: {
            prop: 'state',
            label: '车辆订单状态',
          },
          getText: ({ row }) => {
            if (row.state === 2) {
              return '进行中'
            } else if (row.state === 4) {
              return '已关闭'
            } else {
              return '--'
            }
          },
        },
      ],
    }
  },
  methods: {
    // 计算不同状态的车辆数
    calculatorSum(type) {
      return this.carInfo.reduce((sum, item) => {
        if (Number(item.state) === type) {
          sum++
        }
        return sum
      }, 0)
    },

  },
}
</script>

<style lang="scss" scoped>
  .txt-right{
    text-align: right;
  }
</style>
